/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requestsdeclined1Inputs */

const en_requestsdeclined1 = /** @type {(inputs: Requestsdeclined1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Declined`)
};

const de_requestsdeclined1 = /** @type {(inputs: Requestsdeclined1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgelehnt`)
};

/**
* | output |
* | --- |
* | "Declined" |
*
* @param {Requestsdeclined1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestsdeclined1 = /** @type {((inputs?: Requestsdeclined1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestsdeclined1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestsdeclined1(inputs)
	return de_requestsdeclined1(inputs)
});
export { requestsdeclined1 as "requestsDeclined" }